import { createEffect, sample } from 'effector';
import $$api from 'models/api';

import AlertsService from 'services/AlertsService';

sample({
    clock: [
        $$api.stripe.getCouponsFx.failData,
        $$api.stripe.shippingPaymentFx.failData,
        $$api.stripe.giftPaymentFx.failData,
    ],
    target: createEffect(AlertsService.handleError),
});
